import Vue from "vue";
//export const baseApiUrl = "http://192.168.15.18:3018";
export const baseApiUrl = "https://dados.ml18.com.br";
export const userKey = "__gudma_user";

// Certifique-se de que Vue e Vue.toasted estão acessíveis globalmente
// ou que esta função está sendo usada em um contexto onde eles estão disponíveis.

export function showError(error) {
  let errorMessage = "Erro desconhecido"; // Mensagem padrão para iniciar

  if (error) {
    if (error.response) {
      // O erro veio de uma resposta do servidor (status 4xx, 5xx)
      if (error.response.data) {
        // Tenta extrair a mensagem de 'msg' ou 'mensagem'
        errorMessage =
          error.response.data.msg ||
          error.response.data.mensagem ||
          errorMessage;
      } else {
        // Resposta sem dados, mas com erro de status (ex: 404, 500 sem corpo)
        errorMessage = `Erro do servidor: Status ${error.response.status}`;
      }
    } else if (error.request) {
      // A requisição foi feita, mas não houve resposta (servidor offline, problema de rede)
      errorMessage =
        "Não foi possível conectar ao servidor. Verifique sua conexão de rede.";
    } else if (typeof error === "string") {
      // O erro é uma string simples (ex: `throw "Algo deu errado!"`)
      errorMessage = error;
    } else if (error.message) {
      // Um objeto Error padrão com uma propriedade 'message'
      errorMessage = error.message;
    }
  }

  // Exibe a mensagem usando Vue.toasted
  // Garantindo que a mensagem seja uma string para evitar TypeError
  Vue.toasted.global.defaultError({ msg: String(errorMessage) });
}

export default { baseApiUrl, showError, userKey };
